import usePrefix from '@/hooks/usePrefix';
import { Button, CheckPicker } from '@/components/Bicester';
import React from 'react';
import { ControlLabel, FormGroup } from 'rsuite';
import { ItemDataType } from 'rsuite5/esm/@types/common';
import { FormControl } from '@/components/formik-rsuite';
import { CheckPickerProps } from 'rsuite5';
import _ from 'lodash';
import { FORM_DEFAULT_DISPLAY } from '@/constants/config';

const getLabels = (pickerData: ItemDataType[], valueArray: number[]) => {
  return pickerData
    ?.filter((item) => valueArray.includes(Number(item?.value)))
    ?.map((item) => item?.label)
    ?.join();
};

const BicesterCardPicker = ({
  className,
  isEdit = true,
  required = false,
  cleanable = true,
  placeholder,
  label,
  value,
  formKey,
  disabledItemValues,
  pickerData = [],
  hasBtn = false,
  btnDisabled,
  btnLoading,
  btnLabel,
  onClick,
  menuMaxHeight = 250,
  labelWeight,
  contentWeight,
  ...props
}: {
  className?: string;
  isEdit?: boolean;
  required?: boolean; // 是否必填
  cleanable?: boolean;
  placeholder?: React.ReactNode;
  label?: string;
  formKey: string; // 与field.name一致，只读数据中也要传个key，否则accepter报错
  value?: string | number; // field.value为空或数据不在下拉框中时显示的value，一般用于只读状态显示
  disabledItemValues?: any[];
  pickerData?: ItemDataType[];
  hasBtn?: boolean;
  btnDisabled?: boolean;
  btnLoading?: boolean;
  btnLabel?: React.ReactNode;
  onClick?: () => void;
  menuMaxHeight?: number;
  labelWeight?: number; // label的flex占比
  contentWeight?: number; // content的flex占比
} & Omit<CheckPickerProps<any>, 'data'>) => {
  const { prefix, classname } = usePrefix('bicester-card-item');
  return (
    <div className={`bicester-card-item-wrap ${className ?? ''}`}>
      <FormGroup
        className={`${classname} bicester-card-checkpicker ${
          isEdit ? '' : 'bicester-card-checkpicker-isedit'
        }`}
      >
        {label && (
          <ControlLabel
            className={prefix('label')}
            style={{ ...(labelWeight && { flex: labelWeight }) }}
          >
            <div className={prefix('label-text')}>{label}</div>
            <div
              className={`${prefix('label-divider')} ${isEdit && required ? 'required' : ''}`}
            ></div>
          </ControlLabel>
        )}
        <div
          className={`${prefix('content-wrap')} ${isEdit ? prefix('content-wrap-isedit') : ''}`}
          style={{ ...(contentWeight && { flex: contentWeight }) }}
        >
          {isEdit ? (
            <>
              <FormControl
                className={prefix('content')}
                name={formKey}
                accepter={CheckPicker}
                placeholder={placeholder}
                data={pickerData || []}
                cleanable={cleanable}
                disabledItemValues={disabledItemValues}
                menuMaxHeight={menuMaxHeight}
                {...props}
              />
              {hasBtn && (
                <div className="flex items-center">
                  <Button
                    type="submit"
                    className={prefix('content-btn')}
                    disabled={btnDisabled}
                    loading={btnLoading}
                    onClick={onClick}
                  >
                    {btnLabel}
                  </Button>
                </div>
              )}
            </>
          ) : (
            <FormControl
              name={formKey}
              accepter={({ field }) => (
                <div className={prefix('content-wrap-text')}>
                  {getLabels(pickerData, (_.isNil(field.value) ? value : field.value) || []) ||
                    FORM_DEFAULT_DISPLAY}
                </div>
              )}
            />
          )}
        </div>
      </FormGroup>
    </div>
  );
};

export default BicesterCardPicker;
